import { useEffect, useState } from 'react'

import { applyFiltersToSearch, decodeFilters } from './rosterFilterParams'
import { EMPTY_FILTERS, type CoverageFilter, type RosterFilters, type StatusFilter } from './types'

type UseRosterFiltersOptions = {
  roles: string[]
  supporterIds: string[]
}

export type UseRosterFilters = {
  filters: RosterFilters
  setRoles: (roles: string[]) => void
  setPeople: (people: string[]) => void
  setStatus: (status: StatusFilter) => void
  setCoverage: (coverage: CoverageFilter) => void
  removeRole: (role: string) => void
  removePerson: (id: string) => void
  clear: () => void
}

export const useRosterFilters = (options: UseRosterFiltersOptions): UseRosterFilters => {
  const [filters, setFilters] = useState<RosterFilters>(() =>
    typeof window === 'undefined' ? EMPTY_FILTERS : decodeFilters(window.location.search, options)
  )

  useEffect(() => {
    if (typeof window === 'undefined') return
    const queryString = applyFiltersToSearch(window.location.search, filters)
    const url = queryString ? `${window.location.pathname}?${queryString}` : window.location.pathname
    window.history.replaceState(window.history.state, '', url)
  }, [filters])

  return {
    filters,
    setRoles: (roles) => setFilters((prev) => ({ ...prev, roles })),
    setPeople: (people) => setFilters((prev) => ({ ...prev, people })),
    setStatus: (status) => setFilters((prev) => ({ ...prev, status })),
    setCoverage: (coverage) => setFilters((prev) => ({ ...prev, coverage })),
    removeRole: (role) => setFilters((prev) => ({ ...prev, roles: prev.roles.filter((r) => r !== role) })),
    removePerson: (id) => setFilters((prev) => ({ ...prev, people: prev.people.filter((p) => p !== id) })),
    clear: () => setFilters(EMPTY_FILTERS),
  }
}
